// extracted by mini-css-extract-plugin
export default {"header":"AppHeader_header__zOS+g","labels":"AppHeader_labels__qNoh3","logo":"AppHeader_logo__KT7pO"};